import styled from "styled-components/macro";

export type PortalStatusType = "down" | "maintenance" | "maintenanceUpcoming";

type PortalStatusTheme = {
  redPastel: string;
  redDark: string;
  blueSubtle: string;
  blueDarker: string;
};

const getBackgroundColor = (
  status: PortalStatusType,
  theme: PortalStatusTheme,
): string => {
  switch (status) {
    case "down":
      return theme.redPastel;
    case "maintenance":
    case "maintenanceUpcoming":
      return theme.blueSubtle;
    default:
      return theme.blueSubtle;
  }
};

const getBorderColor = (
  status: PortalStatusType,
  theme: PortalStatusTheme,
): string => {
  switch (status) {
    case "down":
      return theme.redDark;
    case "maintenance":
    case "maintenanceUpcoming":
      return theme.blueDarker;
    default:
      return theme.blueDarker;
  }
};

const getTextColor = (
  status: PortalStatusType,
  theme: PortalStatusTheme,
): string => {
  switch (status) {
    case "down":
      return theme.redDark;
    case "maintenance":
    case "maintenanceUpcoming":
      return theme.blueDarker;
    default:
      return theme.blueDarker;
  }
};

export const StatusBannerWrapper = styled.div<{ status: PortalStatusType }>`
  background-color: ${({ status, theme }) => getBackgroundColor(status, theme)};
  border-left: 2px solid ${({ status, theme }) => getBorderColor(status, theme)};
  padding: 12px 16px 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
`;

export const StatusBannerHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const StatusBannerIconWrapper = styled.div<{ status: PortalStatusType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  color: ${({ status, theme }) => getTextColor(status, theme)};
`;

export const StatusBannerTitle = styled.span<{ status: PortalStatusType }>`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  color: ${({ status, theme }) => getTextColor(status, theme)};
  flex: 1;
`;

export const StatusBannerBody = styled.div`
  padding-left: 40px;
  padding-right: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const StatusBannerMessage = styled.p<{ status: PortalStatusType }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ status, theme }) => getTextColor(status, theme)};
  margin: 0;
`;

export const StatusBannerLink = styled.a<{ status: PortalStatusType }>`
  color: ${({ status, theme }) => getTextColor(status, theme)};
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  &:hover {
    text-decoration: none;
  }
`;
